import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	${minWidth('desktop')} {
		display: grid;
		grid-template-columns: 47.5% 52.5%;
		min-height: 100vh;
	}
`;
